/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */

import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Form, Input, InputNumber, Select } from 'antd'
import _ from 'lodash'
import { Option } from 'antd/es/mentions'
import { useTranslation } from 'react-i18next'
import { MAX_INPUT_10B_NUMBER, MAX_INPUT_SCHEDULE_NUMBER, MIN_INPUT_SCHEDULE_NUMBER } from 'Utils/utils'
import moment from 'moment'
import { getGridColumns } from 'Modules/dashboard/dashboard'
import Editable from './Editable'
import { SeriesOption } from '../../../Modules/dashboard/constant'
import { mergeFieldArray } from '../../../Utils/array'
import { useRoot } from '../../../Hooks'

const SheetTable = styled.table`
  width: 100%;
  margin-top: 38px;
`

const SheetWrapperStyled = styled.tr`

  th {
    background: #3B82F6;
  }

  td {
    border: 0.2px solid #000000;
    min-width: 70px;
    min-height: 22px;

    &:first-child {
      font-weight: 700;
      font-size: 8px;
      /* or 200% */

      text-align: center;
      letter-spacing: 1px;
      text-transform: uppercase;
      line-height: 22px;

      color: #000000;
    }
  }

  th, td {
    flex: 1;
    padding: 0;
    margin: 0;
  }

  tr {
    display: flex;
    width: 100%;
  }
`

const InlineEditInput = styled(InputNumber)`
  width: 100%;
  border-bottom: none !important;
  padding: 0;
  font-weight: 400;
  font-size: 9px;
  /* or 267% */
  display: block;
  line-height: 22px;
  min-height: 22px;
  text-align: center;
  letter-spacing: 1px;
  text-transform: uppercase;

  color: #000000;

  input {
    height: 22px !important;
    text-align: center;
    font-size: 9px;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

const SelectSeriesStyled = styled(Select)`
  width: 100%;

  font-weight: 400;
  font-size: 9px;
  line-height: 16px;
  /* or 267% */

  text-align: center;
  letter-spacing: 1px;
  text-transform: uppercase;
  min-height: 22px;
  color: #000000;

  .ant-select-item-option-contentY {
    font-weight: 400;
    font-size: 9px;
    line-height: 16px;
    /* or 267% */

    text-align: center;
    letter-spacing: 1px;
    text-transform: uppercase;

    color: #000000;
  }

  .ant-select-selector {
    padding: 0 !important;
  }
`
const SelectYearStyled = styled(Select)`
  margin-left: 16px;
  text-align: center;
  text-transform: uppercase;
  
  .ant-select-selector .ant-select-selection-item{
    color: #000;
  }
`

const TitleStartYear = styled.div`
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 12px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;

  position: absolute;
  width: calc(100% - 40px);
`

export default function GridSheet({
  growthSchedulesData,
  arrData,
  yoyData,
  requiredData,
  raisedData,
  scheduleData,
  seriesData,
  editingGROWTH,
  setSubmitData,
  valueImports,
  openCurrencyModal,
  currencyType
}) {
  const [fieldData, setFieldData] = useState([])
  const [yearHeaders, setYearHeaders] = useState(getGridColumns(growthSchedulesData))
  const [form] = Form.useForm()
  const { t } = useTranslation('common')
  const { showModalMessageAction } = useRoot()

  const handleChange = (e, item) => {
    let { value, name } = e.target
    const getName = name.split('-')

    if (getName[0].includes('yoy')) {
      if (value < 0) {
        value = 0
      }
      if (value > 1000000) {
        value = 1000000
      }
    }
    if (value < 0) {
      value = 0
    }

    if (Number.isNaN(Number(value)) || value === '') {
      value = null
    } else {
      value = Number(value)
    }

    let obj = {
      id: item,
      [getName[0]]: value
    }
    const resultData = mergeFieldArray([
      ...growthSchedulesData,
      ...arrData,
      ...yoyData,
      ...requiredData,
      ...raisedData,
      ...scheduleData,
      ...seriesData,
      ...fieldData,
      obj], 'id')
    return setFieldData(resultData)
  }

  useEffect(() => {
    setSubmitData(fieldData)
  }, [fieldData])

  useEffect(() => {
    if (editingGROWTH) {
      setFieldData(mergeFieldArray([
        ...growthSchedulesData,
        ...arrData,
        ...yoyData,
        ...requiredData,
        ...raisedData,
        ...scheduleData,
        ...seriesData
      ], 'id'))
    } else setYearHeaders(getGridColumns(growthSchedulesData))
  }, [editingGROWTH])

  useEffect(() => {
    setYearHeaders(getGridColumns(growthSchedulesData))
  }, [growthSchedulesData])

  useEffect(() => {
    if (valueImports && valueImports.length) {
      const resultData = mergeFieldArray([
        ...growthSchedulesData,
        ...arrData,
        ...yoyData,
        ...requiredData,
        ...raisedData,
        ...scheduleData,
        ...seriesData,
        ...fieldData,
        ...valueImports
      ], 'id')
      setFieldData(resultData)
    }
  }, [valueImports])

  const handleSelectChange = (value, id) => {
    const obj = {
      id,
      series: value
    }
    const resultData = mergeFieldArray([
      ...growthSchedulesData,
      ...arrData,
      ...yoyData,
      ...requiredData,
      ...raisedData,
      ...scheduleData,
      ...seriesData,
      ...fieldData,
      obj
    ], 'id')

    setFieldData(resultData)
  }

  const handleStartYearChange = (value) => {
    const yearData = scheduleData.map((item, index) => ({
      year: value + index,
      id: item.id,
      arr: null,
      raised: null,
      required: null,
      schedule: null,
      series: '',
      yoy: null
    }))

    const resultData = mergeFieldArray([
      ...yearData
    ], 'id')

    setFieldData(resultData)
    setYearHeaders(getGridColumns(resultData))
  }

  const startYear = useMemo(() => (yearHeaders ? yearHeaders[1].field : moment().year()), [yearHeaders])
  return (
    <Form
      className="schedule-form"
      form={form}
      style={{
        overflowX: 'auto'
      }}
    >
      <TitleStartYear>
        {
          editingGROWTH ? (
            <div>
              START YEAR
              <SelectYearStyled
                name="start-year"
                defaultValue={startYear}
                placeholder="Select year"
                onChange={handleStartYearChange}
              >
                {
                  Array(88).fill().map((v, i) => i + 2013).map((value) => <Option key={value} value={value}>{value}</Option>)
                }
              </SelectYearStyled>
            </div>

          ) : <span>START YEAR {startYear}</span>
        }
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => {
            openCurrencyModal()
          }}
        >
          {currencyType && `Scale ${currencyType}`}
        </span>
      </TitleStartYear>
      <SheetTable>
        <SheetWrapperStyled>
          <tr>
            {yearHeaders && yearHeaders.length > 0 && yearHeaders.map((item, index) => (
              <th
                key={index}
              >{item.field}
              </th>
            ))}
          </tr>
        </SheetWrapperStyled>
        <SheetWrapperStyled>
          <tr>
            <td>{t('arr')}</td>
            {arrData && arrData.length > 0 && arrData.map((item, index) => (
              <td key={index}>
                <Editable
                  text={item?.arr ? Number(item?.arr).toLocaleString() : ''}
                  isEditField={editingGROWTH}
                >
                  <InlineEditInput
                    key={`arr-${item.id}-${editingGROWTH}`}
                    defaultValue={item.arr}
                    max={MAX_INPUT_10B_NUMBER}
                    controls={false}
                    type="number"
                    name={`arr-${item.id}`}
                    onBlur={(e) => handleChange(e, item.id)}
                    value={fieldData[index]?.arr}
                  />
                </Editable>
              </td>
            ))}
          </tr>
          <tr>
            <td>{t('yoy')}</td>
            {yoyData && yoyData.length > 0 && yoyData.map((item, index) => (
              <td key={index}>
                <Editable text={item?.yoy != null ? `${Number(item?.yoy).toLocaleString()}%` : ''} isEditField={editingGROWTH}>
                  <InlineEditInput
                    key={`yoy-${item.id}-${editingGROWTH}`}
                    type="number"
                    min={MIN_INPUT_SCHEDULE_NUMBER}
                    max={MAX_INPUT_SCHEDULE_NUMBER}
                    controls={false}
                    defaultValue={item.yoy != null ? `${item.yoy}` : ''}
                    name={`yoy-${item.id}`}
                    onBlur={(e) => handleChange(e, item.id)}
                    value={fieldData[index]?.yoy}
                  />
                </Editable>
              </td>
            ))}
          </tr>
          <tr>
            <td>{t('required')}</td>
            {requiredData && requiredData.length > 0 && requiredData.map((item, index) => (
              <td key={index}>
                <Editable
                  text={item?.required != null ? Number(item?.required).toLocaleString() : ''}
                  isEditField={editingGROWTH}
                >
                  <InlineEditInput
                    key={`required-${item.id}-${editingGROWTH}`}
                    type="number"
                    min={MIN_INPUT_SCHEDULE_NUMBER}
                    max={MAX_INPUT_10B_NUMBER}
                    controls={false}
                    defaultValue={item.required != null ? item.required : ''}
                    name={`required-${item.id}`}
                    onBlur={(e) => handleChange(e, item.id)}
                    value={fieldData[index]?.required}
                  />
                </Editable>
              </td>
            ))}
          </tr>
          <tr>
            <td>{t('raised')}</td>
            {raisedData && raisedData.length > 0 && raisedData.map((item, index) => (
              <td key={index}>
                <Editable text={item?.raised != null ? Number(item?.raised).toLocaleString() : ''} isEditField={editingGROWTH}>
                  <InlineEditInput
                    key={`raised-${item.id}-${editingGROWTH}`}
                    type="number"
                    min={MIN_INPUT_SCHEDULE_NUMBER}
                    max={MAX_INPUT_10B_NUMBER}
                    controls={false}
                    defaultValue={item.raised != null ? item.raised : ''}
                    name={`raised-${item.id}`}
                    onBlur={(e) => handleChange(e, item.id)}
                    value={fieldData[index]?.raised}
                  />
                </Editable>
              </td>
            ))}
          </tr>
          <tr>
            <td>{t('schedule')}</td>
            {scheduleData && scheduleData.length > 0 && scheduleData.map((item, index) => (
              <td key={index}>
                <Editable
                  text={item?.schedule != null ? Number(item?.schedule).toLocaleString() : ''}
                  isEditField={editingGROWTH}
                >
                  <InlineEditInput
                    key={`schedule-${item.id}-${editingGROWTH}`}
                    type="number"
                    min={MIN_INPUT_SCHEDULE_NUMBER}
                    max={MAX_INPUT_10B_NUMBER}
                    controls={false}
                    defaultValue={item.schedule != null ? item.schedule : ''}
                    name={`schedule-${item.id}`}
                    onBlur={(e) => handleChange(e, item.id)}
                    value={fieldData[index]?.schedule}
                  />
                </Editable>
              </td>
            ))}
          </tr>
          <tr>

            <td>{t('series')}</td>
            {seriesData && seriesData.length > 0 && seriesData.map((item, index) => (
              <td key={index}>
                <Editable text={item?.series || ''} isEditField={editingGROWTH}>
                  <SelectSeriesStyled
                    name={`series-${item.id}`}
                    defaultValue={item.series ? item.series : ''}
                    placeholder="Select Series"
                    value={fieldData[index]?.series}
                    onChange={(value) => handleSelectChange(value, item.id)}
                  >
                    {
                      SeriesOption.map((select, i) => <Option key={i} value={select.label}>{select.label}</Option>)
                    }
                  </SelectSeriesStyled>
                </Editable>
              </td>
            ))}
          </tr>
        </SheetWrapperStyled>
      </SheetTable>
    </Form>
  )
}
